import type { INoteLink } from 'entities/offerNote/config/offerNote.texts';

export const getPhoneLinks = (phones?: string[], linkTitle?: string): INoteLink[] | undefined => {
  return phones?.[0]
    ? [
        {
          type: 'phone',
          label: phones[0],
          href: `tel:${phones[0]}`,
          title: linkTitle,
        },
      ]
    : undefined;
};
